var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "entity-main-data" }, [
    _c("div", { staticClass: "item" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Fecha")]),
      _c("span", [_vm._v(_vm._s(_vm.payment.dueDate))]),
    ]),
    _c("div", { staticClass: "item" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Pago Nro.")]),
      _c("span", [_vm._v(_vm._s(_vm.payment.paymentNumber))]),
    ]),
    _c("div", { staticClass: "item" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Monto")]),
      _c("span", [
        _vm._v("UF " + _vm._s(_vm.formatNumber(_vm.payment.monthlyPayment))),
      ]),
    ]),
    _c("div", { staticClass: "item" }, [
      _vm.showPayment
        ? _c(
            "div",
            {
              staticClass: "movement-type field is-grouped item",
              attrs: { id: `item-tag-${_vm.pos}` },
            },
            [
              _vm.payment.isPaid
                ? _c(
                    "span",
                    {
                      staticClass: "tag is-medium is-success is-light",
                      attrs: { id: "payment-paid-tag" },
                    },
                    [_vm._v(" PAGADO ")]
                  )
                : _c(
                    "span",
                    {
                      staticClass: "tag is-medium is-danger is-light",
                      attrs: { id: "payment-not-paid-tag" },
                    },
                    [_vm._v(" NO PAGADO ")]
                  ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }